import React from "react";
import { Container } from "react-bootstrap";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import { useTranslation } from 'react-i18next';

const Map = ({ lang, propiedad }) => {

    const { t } = useTranslation();
    var preidioma = "";
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <MapContainer center={[propiedad.latitud, propiedad.longitud]} zoom={18} scrollWheelZoom={false}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[propiedad.latitud, propiedad.longitud]}></Marker>
            </MapContainer>
            {/* <div className="map-bottom mapboxgl-map"></div>*/}
        </>
    );
};
export default Map;
